module.exports = __webpack_public_path__ + "static/media/b-arts-major-5_LR.36090957.jpg";